import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import type {
  SparkRatingAttributes,
  SingleSparkRatingResponse,
} from 'types/Spark/SparkRating';
import { useUserStore } from 'stores';
import React from 'react';

type mutationVariables = Partial<SparkRatingAttributes>;

export function useAddSparkRating() {
  const queryClient = useQueryClient();
  const currentUserID = useUserStore(
    React.useCallback((state) => state.currentUserID, [])
  );
  const addSparkRating = (sparkRating: mutationVariables) => {
    if (!sparkRating.sparkID || !currentUserID) {
      Promise.reject('something went wrong while rating the spark!');
    }
    const body = {
      data: {
        type: SPARK_RESOURCE_TYPES.SPARK_RATINGS,
        attributes: { userID: currentUserID, ...sparkRating },
      },
    };

    return fetchWrapper<SingleSparkRatingResponse>({
      url: SPARK_RESOURCE_TYPES.SPARK_RATINGS,
      method: 'POST',
      body: body,
    });
  };

  return useMutation('addSparkRating', addSparkRating, {
    onSuccess: () => {
      queryClient.invalidateQueries('sparks');
      queryClient.invalidateQueries('SparkRun');
      queryClient.invalidateQueries('ratings paginated');
      toastr.success('Successfully rated the Spark');
    },
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`failed to Post Spark Rating: ${error.message}`);
      }
    },
  });
}
